import { InputProps } from './interface';
import { FC } from 'react';

const CertifyingAuthority: FC<InputProps> = ({ register }) => {
  return <input className="hidden" type="text" {...register('certifying_authority')} />;
};

export default CertifyingAuthority;
